import styled from 'styled-components';

export const TabTableContainer = styled.div`
  height: 500px;
  width: 100%;
  padding: 5px;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h4`
  padding: 15px 15px 15px 0;
`;
